import { render, staticRenderFns } from "./MediaView.vue?vue&type=template&id=6b5525c8&scoped=true&"
import script from "./MediaView.vue?vue&type=script&lang=js&"
export * from "./MediaView.vue?vue&type=script&lang=js&"
import style0 from "./MediaView.vue?vue&type=style&index=0&id=6b5525c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5525c8",
  null
  
)

export default component.exports